import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"สิทธิปกครองบุตรและอำนาจปกครอง — Child Custody ในไทย","metaTitle":"สิทธิปกครองบุตรไทย — ค่าเลี้ยงดู อำนาจปกครอง ข้ามชาติ | NYC","metaDesc":"คดีสิทธิปกครองบุตร ค่าเลี้ยงดู อำนาจปกครองไทย รวมคดีข้ามชาติ Hague Convention 1980 ค่าปรึกษาฟรี บริการ"},"en":{"h1":"Child Custody & Parental Rights in Thailand","metaTitle":"Thai Child Custody — Support, Hague Convention 1980 | NYC","metaDesc":"Thai child custody, support and parental-authority cases including cross-border matters under Hague 19 — Free consultation — message us for a same-day answer."}} as const;

export const Route = createFileRoute("/family/child-custody")({
  head: () => {
    const url = `${SEO_SITE}/family.child-custody`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/family/child-custody", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/family/child-custody", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/family/child-custody", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/family/child-custody", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/family.child-custody", "/en/family.child-custody")],
    };
  },
  component: () => <SubServicePage slug="family/child-custody" locale="th" />,
});
